export function enableNavBar() {

    
    if($('#mainNav').length > 0) {

        // Enable fade-in and fade-out on dropdowns
        $("#mainNav .nav-item.dropdown").on("mouseenter", function() {
            $(this).find(".dropdown-menu").fadeIn(200);
        })

        $("#mainNav .nav-item.dropdown").on("mouseleave", function() {
            $(this).find('.dropdown-menu').fadeOut(200);
        })


        // Activate scrollspy to add active class to navbar items on scroll
        $('body').scrollspy({
            target: '#mainNav',
            offset: 54
        });

        // Collapse Navbar
        var navbarCollapse = function() {
            if ($("#mainNav").offset().top > 100) {
                $("#mainNav").addClass("navbar-shrink");
                $("#mainContent").addClass("navbar-shrink");
            } else {
                $("#mainNav").removeClass("navbar-shrink");
                $("#mainContent").removeClass("navbar-shrink");
            }
        };
        // Collapse now if page is not at top
        navbarCollapse();
        // Collapse the navbar when page is scrolled
        $(window).on("scroll", navbarCollapse);
    }
    
  
}